module.exports = {"content":{},"productInfo":{"code":"{6FC9C825-A753-4934-BBEE-0BE47F7EE713}","name":"ポルトガル語（ブラジル）　初中級","serialHead":"ATAVS","courseResourceIDs":[{"levelNo":1,"resourceID":"01b70edeaf05b7a8ac91056a488d66c0d29dc933"},{"levelNo":2,"resourceID":"d541e118f6381d1abd13f8c778ee77ca72eea5c1"},{"levelNo":3,"resourceID":"782aa645ffc5893bc81bd02bb100d1020d9fb8e9"}],"language":"pt-BR","challengeCount":21591},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1